const eventCardBg = "bg-ka-grey-light bg-classic-primary40 bg-pride-sky bg-pastel-turquoise-light bg-dark-grey-dark";
const eventCardText = "text-ka-black text-classic-black text-pride-white text-pastel-black text-dark-white";
const eventCardLink = "text-ka-primary text-classic-primary text-pride-cherry text-pastel-primary text-dark-grass";

export default (params) => {
  const {
    cardClass,
    arrow,

    title,
    border
  } = params;

  let html = `
    <div
      id="${cardClass}__color"
      class="${cardClass}__color ${eventCardBg} ${eventCardText} position-relative"
      style="--left: ${arrow}px;"
    >
      <div
        id="${cardClass}__border"
        class="${cardClass}__border ${border}"
      >
      </div>
      <div class="ps-4 pe-4">
        <div class="text-reset fw-bold py-3">
          <span
            id="${cardClass}__title"
            class="fw-bold text-reset"
          >
            ${title}
          </span>
        </div>
      </div>
    </div>
  `;

  html.trim();
  return html;
};
